import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Box = styled.div`
  font-size: ${themeStyle.fontSize14};
  line-height: 22px;
  font-weight: ${themeStyle.fontMedium};
  color: ${themeStyle.varInkMain};

  display: flex;
  align-items: start;
  gap: 12px;
  padding: 24px;
  background: ${themeStyle.varBlueLight};
  border-radius: ${themeStyle.radiusLarge};

  margin-bottom: 24px;

  p {
    margin: 0;
  }

  a {
    cursor: pointer;
    text-decoration: underline;
  }
`;

export const FlipIcon = styled.div`
  transform: scaleY(-1);
`;
